import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const FileDoc = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.5 4.5V2.5L2.5 2.5L2.5 13.5H10.5V11.5H12V13.5C12 14.3284 11.3284 15 10.5 15H2.5C1.67157 15 1 14.3284 1 13.5V2.5C1 1.67157 1.67157 1 2.5 1H10.5C11.3284 1 12 1.67157 12 2.5V4.5H10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.05392 6.13333H3.75V9.46667H5.05392C6.15196 9.46667 6.90686 8.73333 6.90686 7.8C6.90686 6.86667 6.08333 6.13333 5.05392 6.13333ZM4.71078 6.93333H5.05392C5.60294 6.93333 6.01471 7.26667 6.01471 7.8C6.01471 8.33333 5.60294 8.66667 5.12255 8.66667H4.71078V6.93333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2402 9.6C10.3382 9.6 11.1618 8.73333 11.1618 7.8C11.1618 6.86667 10.3382 6 9.2402 6C8.14216 6 7.31863 6.8 7.31863 7.8C7.31863 8.8 8.14216 9.6 9.2402 9.6ZM9.2402 8.73333C8.69118 8.73333 8.27941 8.33333 8.27941 7.8C8.27941 7.26667 8.69118 6.86667 9.2402 6.86667C9.78922 6.86667 10.201 7.26667 10.201 7.8C10.201 8.33333 9.78922 8.73333 9.2402 8.73333Z"
      fill="currentColor"
    />
    <path
      d="M13.4951 8.73333C12.9461 8.73333 12.5343 8.33333 12.5343 7.8C12.5343 7.26667 12.9461 6.86667 13.4951 6.86667C14.0441 6.86667 14.3873 7.26667 14.3873 7.26667L14.9363 6.66667C14.9363 6.66667 14.4559 6 13.4951 6C12.3971 6 11.5735 6.8 11.5735 7.8C11.5735 8.8 12.3971 9.6 13.4951 9.6C14.5245 9.6 15.0049 8.93333 15.0049 8.93333L14.4559 8.33333C14.4559 8.33333 14.1127 8.73333 13.4951 8.73333Z"
      fill="currentColor"
    />
  </Icon>
));

export default FileDoc;
